// Lightweight client-side scam-signal detection for marketplace chats.
const SCAM_PATTERNS = [
  /western union/i, /moneygram/i, /gift ?cards?/i, /wire transfer/i,
  /pay(?:ment)?\s+(?:in\s+)?advance/i, /advance\s+payment/i, /upfront\s+payment/i,
  /send\s+money\s+first/i, /pay\s+first/i, /prepay/i, /deposit\s+first/i,
  /bitcoin\s+only/i, /crypto\s+only/i, /\botp\b/i, /pin\s*code/i, /card\s+number/i,
  /\bcash\s?app\b/i, /\bzelle\b/i, /processing\s+fee/i, /clearance\s+fee/i,
  /shipping\s+company\s+will/i, /agent\s+will\s+contact/i, /verification\s+fee/i,
];

export function isScammy(text) {
  if (!text) return false;
  return SCAM_PATTERNS.some((re) => re.test(text));
}
